import app from '../../main'
const qs = require('qs')

export default {
    namespaced: true,
    state: {
        orders: [],
        mobileOrders: [],
        order: {},
        pagination: {
            page: 1,
            totalPages: 1,
            totalRecords: 0,
            pageSize: 10
        },
        errors: {
            getOrders: '',
            getOrder: ''
        }
    },
    getters: {
        orderItemsCountByBrand: state => brandId => {
            return state.order.ItemsByBrand.find(
                brand => brand.BrandID === brandId
            ).Items.reduce(
                (acc, item) => acc + parseInt(item.pivot.Quantity),
                0
            )
        },
        orderItemsPriceByBrand: state => brandId => {
            return state.order.ItemsByBrand.find(
                brand => brand.BrandID === brandId
            ).Items.reduce((acc, item) => {
                let price =
                    parseInt(item.pivot.Quantity) *
                    parseFloat(item.pivot.Price || 0)
                //если цена за грамм
                if (parseInt(item.PriceUnit) == 2) {
                    price = price * parseInt(item.Weight)
                }
                return acc + price
            }, 0)
        },
        orderTotalPrice(state) {
            return state.order.ItemsByBrand.reduce((acc, brand) => {
                return (
                    acc +
                    brand.Items.reduce((brandAcc, item) => {
                        let price =
                            parseInt(item.pivot.Quantity) *
                            parseFloat(item.pivot.Price)

                        //если цена за грамм
                        if (parseInt(item.PriceUnit) == 2) {
                            price = price * parseInt(item.Weight)
                        }

                        return brandAcc + price
                    }, 0)
                )
            }, 0)
        }
    },
    mutations: {
        SET_ORDERS(state, payload) {
            state.orders = payload
        },
        SET_MOBILE_ORDERS(state, payload) {
            if (state.pagination.page == 1) {
                state.mobileOrders = payload
            } else {
                state.mobileOrders = [...state.mobileOrders, ...payload]
            }
        },
        CLEAR_ORDERS(state) {
            state.orders = []
            state.mobileOrders = []
            state.pagination = {
                page: 1,
                totalPages: 1,
                totalRecords: 0,
                pageSize: 10
            }
        },
        SET_ORDER(state, payload) {
            state.order = payload
        },
        CLEAR_ORDER(state) {
            state.order = {}
        },
        SET_PAGINATION(state, payload) {
            state.pagination[payload.key] = payload.val
        },
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        clearOrders({ commit }) {
            commit('CLEAR_ORDERS')
        },
        clearOrder({ commit }) {
            commit('CLEAR_ORDER')
        },
        async getOrders({ commit, state }, data) {
            commit('SET_ERRORS', {
                key: 'getOrders',
                val: ''
            })

            const url = '/supplier/orders'

            try {
                const resp = await this.$axios.get(url, {
                    params: {
                        ...data,
                        items: state.pagination.pageSize
                    },
                    paramsSerializer: function(params) {
                        return qs.stringify(params, { arrayFormat: 'brackets' })
                    }
                })
                app.$Progress.finish()

                commit('SET_ORDERS', resp.data)

                commit('SET_PAGINATION', {
                    key: 'page',
                    val: resp.headers['page'] * 1
                })
                commit('SET_PAGINATION', {
                    key: 'totalPages',
                    val: resp.headers['total-pages'] * 1
                })
                commit('SET_PAGINATION', {
                    key: 'totalRecords',
                    val: resp.headers['total-records'] * 1
                })
                commit('SET_PAGINATION', {
                    key: 'pageSize',
                    val: resp.headers['page-size'] * 1
                })

                if (
                    (data && data.isMobilePagination) ||
                    state.pagination.page == 1
                ) {
                    commit('SET_MOBILE_ORDERS', resp.data)
                }
            } catch (e) {
                app.$Progress.fail()
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getOrders',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getOrders',
                        val: 'Ошибка'
                    })
                }

                throw e
            }
        },
        async getOrder({ commit, state }, id) {
            commit('SET_ERRORS', {
                key: 'getOrder',
                val: ''
            })

            const url = `/supplier/orders/${id}`

            try {
                const resp = await this.$axios.get(url)
                app.$Progress.finish()

                commit('SET_ORDER', resp.data)
            } catch (e) {
                app.$Progress.fail()
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getOrder',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getOrder',
                        val: 'Ошибка'
                    })
                }

                throw e
            }
        }
    }
}
